<!-- 写回答页面 -->
<template>
    <div class="write-answer">
        <div class="answer-card">
            <div class="header">
                <div class="left">
                    <veui-button ui="text" @click="goBack" class="go-back">
                        返回
                    </veui-button>
                    <div class="vertical-line"></div>
                    <div class="title">写回答</div>
                </div>
                <veui-button ui="text" class="tips-btn" @click="toAnswerRules">
                    如何回答
                </veui-button>
            </div>
            <div class="line"></div>
            <section>
                <div class="content">
                    <div class="ques-title">{{ quesInfo.question }}</div>
                    <div class="unfold-detail" :class="isFold ? 'hide' : ''">
                        <div class="ques-detail" v-if="false">
                            {{ quesInfo.question }}
                        </div>
                        <!-- 本期图片不做，后边加 -->
                        <div class="pics" v-if="false && !isFold">
                            <img
                                src="https://midpf-mp-pub.cdn.bcebos.com/908879662890c9c0a499e44cb6b6bf82.jpeg"
                                alt="加载失败"
                                @click="showModal"
                            />
                        </div>
                    </div>
                    <div class="opera" v-if="false">
                        <veui-button
                            v-if="isFold"
                            ui="text"
                            @click="isFold = false"
                            class="unfold-btn"
                            >展开</veui-button
                        >
                        <veui-button
                            v-if="!isFold"
                            ui="text"
                            @click="isFold = true"
                            class="fold-btn"
                            >收起</veui-button
                        >
                    </div>
                </div>
                <div class="editor">
                    <customize-editor
                        :quill-id="0"
                        :quill-toolbar="quillToolbar"
                        external-class="write-answer-editor"
                        quill-placeholder="请输入回答"
                        ref="editor"
                        :upload-url="url"
                        :is-default-upload="false"
                    >
                    </customize-editor>
                </div>
            </section>
            <!-- 预览图片 -->
            <div v-if="isPicPreview">
                <picReview
                    :pic="previewPic"
                    @closePreview="isPicPreview = false"
                />
            </div>
            <veui-confirm-box
                title=""
                :open.sync="isShowConfirm"
                @ok="goBack"
                @cancel="isShowConfirm = false"
            >
                <p>回答暂未发布，是否取消？</p>
            </veui-confirm-box>
        </div>
        <div class="footer">
            <veui-button ui="strong" class="cancel-button" @click="cancel">
                取消
            </veui-button>
            <veui-button
                ui="primary"
                class="submit-button"
                :loading="isLoading"
                @click="submit"
            >
                发布
            </veui-button>
        </div>
    </div>
</template>

<script>
/**
 * @file write-answer.vue
 * @desc 写回答组件
 * @author dingzhenyue@baidu.com
 */
import { Button, ConfirmBox } from 'veui';
import CustomizeEditor from '@/components/customize-editor';
import picReview from '@/components/picReview.vue';

export default {
    name: 'write-answer',
    components: {
        'veui-button': Button,
        CustomizeEditor,
        picReview,
        'veui-confirm-box': ConfirmBox
    },
    props: {
        // 问题的信息
        quesInfo: {
            type: Object,
            default: () => {}
        },
        consumeType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            quillToolbar: [
                ['bold', 'italic', 'underline'],
                [{ header: 1 }, { header: 2 }, 'blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [
                    { indent: '-1' },
                    { indent: '+1' },
                    { direction: 'rtl' },
                    { align: [] }
                ],
                ['link', 'image']
            ],
            // 是否折叠
            isFold: true,
            // 是否图片预览
            isPicPreview: false,
            // 预览图片
            previewPic:
                'https://midpf-mp-pub.cdn.bcebos.com/908879662890c9c0a499e44cb6b6bf82.jpeg',
            // 是否展示取消确认弹框
            isShowConfirm: false,
            // 图片上传链接
            url: '/bp/api/uploadIknowPic?ajax=1&bdstoken=',
            // 提交中
            isLoading: false
        };
    },
    mounted() {
        // 写回答曝光打点
        this.$log &&
            this.$log.send({
                type: 'show',
                value: 'write-answer-pv'
            });
    },
    methods: {
        /**
         * 答案填写完成，返回主页面
         */

        goBack() {
            this.$emit('closeWriteCard');
        },

        /**
         * 点击预览
         */

        showModal() {
            this.isPicPreview = true;
        },

        /**
         * 点击发布提交
         */

        submit() {
            let content = this.$refs.editor?.content || '';
            // 写回答打点
            this.$log &&
                this.$log.send({
                    type: 'clk',
                    value: 'write-submit'
                });
            if (!content) {
                this.$toast.error('请填写回答');
                return;
            }
            if (content.includes('</a>')) {
                let arr = content.split('<a ');
                arr.forEach((element, index) => {
                    if (index) {
                        arr[index] =
                            'class="iknow-ueditor-link" title="" ' + arr[index];
                    }
                });
                content = arr.join('<a ');
            }
            // 提交
            this.postData(content);
        },

        /**
         * 取消发布
         */

        cancel() {
            this.isShowConfirm = true;
            // 取消发布打点
            this.$log &&
                this.$log.send({
                    type: 'clk',
                    value: 'write-cancel'
                });
        },

        /**
         * 打开回答规则页面
         */

        toAnswerRules() {
            window.open(
                'http://zhidao.baidu.com/api/proxy?url=/s/guideline/answer.html'
            );
        },
        /**
         * 提交回答
         * @param {String} content 输入的回答
         */

        postData(content) {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            // 写回答打点
            this.$log && this.$log.send({
                type: 'clk',
                value: 'post-data'
            });
            this.$http
                .post('/bp/api/offqr/reply', {
                    content,
                    clue_id: this.quesInfo?.clue_id || '',
                    use_business: this.consumeType === '1'
                })
                .then(res => {
                    this.isLoading = false;
                    if (res && +res.code === 120005) {
                        this.$toast.error(res && res.msg || '咨询已被本律所律师回答');
                        return;
                    }
                    if (res && +res.code === 0) {
                        this.$toast.success('答案提交成功');
                        this.$emit('submitSuccess');
                        return;
                    }
                    this.$toast.error((res && res.msg) || '回答提交失败');
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style lang='less' scoped>
.write-answer {
    height: 100%;
    overflow: hidden;
    position: relative;

    .footer {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px -1px 10px 0px rgba(0, 0, 0, 0.1);
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        z-index: 1;

        button {
            height: 40px;
            width: 86px;
            border-radius: 5px;
        }

        .submit-button {
            margin-left: 24px;
            background-color: #3855d5;
        }
    }
}
.answer-card {
    background: #fff;
    box-shadow: 0px 6px 14px 0px rgba(227, 233, 237, 0.35);
    border-radius: 8px;
    padding: 38px 66px 38px 33px;
    height: 100%;
    position: relative;
    width: 100%;
    overflow: auto;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFangSC-Regular;
        color: #333333;

        .left {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .go-back {
                position: relative;
                padding-left: 12px;

                &::before {
                    content: "";
                    position: absolute;
                    height: 12px;
                    width: 10px;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png)
                        no-repeat center center / 100% 100%;
                }
            }

            .vertical-line {
                height: 10px;
                width: 1px;
                background: #9d9d9d;
                margin: 0 10px;
            }

            /deep/ .veui-button,
            .title {
                font-size: 16px;
                line-height: 16px;
                font-weight: 400;
            }
        }

        .tips-btn {
            font-size: 14px;
            color: #0052cc;
            line-height: 14px;
            font-weight: 400;
        }
    }

    .line {
        height: 1px;
        background: #e9ecf3;
        width: 100%;
        margin: 30px 0 20px;
    }

    .editor {
        margin-top: 10px;
        padding-bottom: 50px;

        .edit-container.write-answer-editor {
            width: 100%;

            /deep/ .ql-container.ql-snow {
                width: 100%;
                height: 316px;
            }
        }
    }

    .content {
        color: #333333;
        text-align: justify;

        .ques-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            line-height: 28px;
            font-weight: 500;
        }

        .unfold-detail {
            position: relative;

            .ques-detail {
                font-size: 14px;
                line-height: 24px;
                font-weight: 400;
                margin-top: 14px;
            }

            .pics {
                height: 102px;
                display: flex;
                margin-top: 10px;

                img {
                    height: 102px;
                    width: 160px;
                    border-radius: 10px;
                    border-radius: 8px;
                    margin-right: 10px;
                    cursor: pointer;
                }
            }

            &.hide {
                display: flex;
                align-items: flex-end;
            }
        }

        .opera {
            text-align: right;
            height: 24px;

            button {
                font-size: 14px;
                color: #0052cc;
                line-height: 14px;
                font-weight: 400;
                padding-right: 15px;
            }

            .unfold-btn {
                position: relative;

                &:before {
                    content: "";
                    position: absolute;
                    right: 0;
                    width: 11px;
                    height: 10px;
                    background: url(https://lvlin-base.cdn.bcebos.com/bend/icon-down.png)
                        no-repeat center center / 100% 100%;
                }
            }

            .fold-btn {
                position: relative;

                &:before {
                    content: "";
                    position: absolute;
                    right: 0;
                    width: 11px;
                    height: 10px;
                    background: url(https://lvlin-base.cdn.bcebos.com/bend/icon-show.png)
                        no-repeat center center / 100% 100%;
                }
            }
        }
    }
}
</style>
